module.exports = __webpack_public_path__ + "media/audio83.d3389423.mp3";